import { useCallback, useEffect, useState } from 'react';
import { callCenterObjectionsApi } from '../../../utils/api';

/**
 * کش اشتراکی لیست اعتراض‌ها: همه Selectها و چیپ‌های یک صفحه (مثلاً هر ردیف جدول تماس‌ها) با یک درخواست کار می‌کنند.
 */
let cache = null;
let inflight = null;
const listeners = new Set();

const notify = () => listeners.forEach((listener) => listener(cache));

const fetchObjections = async () => {
  if (!inflight) {
    inflight = callCenterObjectionsApi.getAll()
      .then((res) => {
        const payload = res?.data ?? [];
        // آرایه تازه تا React حتماً تغییر را تشخیص دهد
        cache = [...(Array.isArray(payload) ? payload : payload.data ?? [])];
        notify();
        return cache;
      })
      .finally(() => {
        inflight = null;
      });
  }
  return inflight;
};

/** پس از هر تغییر CRUD فراخوانی شود تا همه کامپوننت‌ها لیست تازه را بگیرند */
export const refreshCallObjections = () => fetchObjections();

export const useCallObjections = () => {
  const [objections, setObjections] = useState(cache || []);
  const [loading, setLoading] = useState(!cache);

  useEffect(() => {
    const listener = (next) => setObjections(next || []);
    listeners.add(listener);

    if (!cache) {
      fetchObjections()
        .catch(() => {})
        .finally(() => setLoading(false));
    }

    return () => listeners.delete(listener);
  }, []);

  const reload = useCallback(async () => {
    setLoading(true);
    try {
      await fetchObjections();
    } finally {
      setLoading(false);
    }
  }, []);

  return { objections, loading, reload };
};

export default useCallObjections;
